import React from "react";

function TopBar() {
  return (
    <div>
      <div className="ltn__header-top-area section-bg-6">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="ltn__top-bar-menu">
                <ul>
                  <li>
                    <a href="mailto:contato@matrixterra.com.br">
                      <i className="icon-mail" /> contato@matrixterra.com.br
                    </a>
                  </li>
                  <li><a target="_blank" href="https://www.instagram.com/matrix_terra/" title="Instagram"><i className="fab fa-instagram" />@matrix_terra </a></li>
                  <li><a target="_blank" href="https://www.facebook.com/matrixterra/" title="Facebook"><i className="fab fa-facebook-f" />Matrix Terra </a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopBar;
